import React from 'react';
import './Moldcavity.css';



const Moldcavity = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Powerjet 72 Cavity PET Preform Molding Solution</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model:</strong> </p>
                    <p><strong>Mold Cavity:</strong> </p>
                    <p><strong>Weight:</strong> </p>
                    <p><strong>Auxiliary Equipment:</strong></p>
                    <p><strong>Cycle Time:</strong></p>
                    <p><strong>Output/Unit/Hour:</strong></p>
                    <p><strong>Output/Unit/Day:</strong></p>
                    <p><strong>Material Ton/Day:</strong></p>
                </div>
                <div className="right-column">
                    <p> KPET3105L-E6（57kw Servo system + 80kw Electric）</p>
                    <p>72 Cavities</p>
                    <p>13.5g Water Bottle Preform</p>
                    <p> 2000L drying system, 40P water cooling machine</p>
                    <p> 12.9s</p>
                    <p> 20,093 piece</p>
                    <p> 4,82,232 piece</p>
                    <p> 6.5T PET material</p>
                </div>
            </div>
        </div>
    );
};

export default Moldcavity;
